import React from "react";
import FieldMultilang from "./FieldMultilang";

export default function ShortDescriptionMultilang({
  values,
  handleChange,
  availableLanguages = [],
  valuesLng = {},
  defaultLanguage = "",
  handleValuesLng,
}) {
  return (
    <FieldMultilang
      label="Descrizione breve"
      name="short_descr"
      value={values.short_descr}
      onChange={handleChange("short_descr")}
      availableLanguages={availableLanguages}
      valuesLng={valuesLng.short_descr}
      defaultLanguage={defaultLanguage}
      handleValuesLng={handleValuesLng && handleValuesLng("short_descr")}
      fullWidth
      multiline
      hasFormat
      formatValue={values.short_descr_format}
      onFormatChange={handleChange("short_descr_format")}
    />
  );
}
